(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["summer-discount-banner"] && !Shopify.designMode) return;
  try {
    (() => {
    const banner = document.querySelector('[data-nv-summer-discount]');
    if (!banner) return;

    const closeButton = banner.querySelector('[data-nv-summer-discount-close]');
    const countdown = banner.querySelector('[data-nv-summer-discount-countdown]');
    const cycleAnchor = Date.parse(banner.dataset.nvPromotionCycleAnchor || '');
    const cycleHours = Number.parseFloat(banner.dataset.nvPromotionCycleHours || '48');
    const cycleDurationMilliseconds = cycleHours * 60 * 60 * 1000;
    const impressionKey = 'nv-summer-discount-10-three-items-recurring-v1';
    const maximumImpressions = 2;
    let promotionEndsAt;
    let closeTimer;
    let countdownTimer;

    const getCurrentCycleEnd = (now = Date.now()) => {
      if (!Number.isFinite(cycleAnchor) || !Number.isFinite(cycleDurationMilliseconds) || cycleDurationMilliseconds <= 0) {
        return now + (48 * 60 * 60 * 1000);
      }
      if (now < cycleAnchor) return cycleAnchor;
      const completedCycles = Math.floor((now - cycleAnchor) / cycleDurationMilliseconds);
      return cycleAnchor + ((completedCycles + 1) * cycleDurationMilliseconds);
    };

    const readImpressions = () => {
      try {
        return Number.parseInt(window.sessionStorage.getItem(impressionKey) || '0', 10) || 0;
      } catch (error) {
        return 0;
      }
    };

    const writeImpressions = (value) => {
      try {
        window.sessionStorage.setItem(impressionKey, String(value));
      } catch (error) {
        return;
      }
    };

    const updateCountdown = () => {
      const now = Date.now();
      if (!Number.isFinite(promotionEndsAt) || promotionEndsAt <= now) {
        promotionEndsAt = getCurrentCycleEnd(now);
      }

      const remainingMilliseconds = Math.max(0, promotionEndsAt - now);
      const totalSeconds = Math.floor(remainingMilliseconds / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      if (countdown) {
        countdown.dateTime = new Date(promotionEndsAt).toISOString();
        countdown.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
      }
    };

    function closeBanner() {
      window.clearTimeout(closeTimer);
      window.clearInterval(countdownTimer);
      banner.classList.remove('is-visible');
      window.setTimeout(() => {
        banner.hidden = true;
      }, 220);
    }

    const showBanner = () => {
      updateCountdown();
      const impressions = readImpressions();
      if (impressions >= maximumImpressions) return;
      writeImpressions(impressions + 1);
      banner.hidden = false;
      window.requestAnimationFrame(() => {
        banner.classList.add('is-visible');
        countdownTimer = window.setInterval(updateCountdown, 1000);
        closeTimer = window.setTimeout(closeBanner, 10000);
      });
    };

    document.documentElement.classList.remove('nv-summer-promotion-expired');
    promotionEndsAt = getCurrentCycleEnd();
    closeButton?.addEventListener('click', closeBanner);
    updateCountdown();
    if (document.readyState === 'complete') {
      window.setTimeout(showBanner, 200);
    } else {
      window.addEventListener('load', () => window.setTimeout(showBanner, 200), { once: true });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
